import type { CSSProperties } from 'react';

interface HudScrubberProps {
  /** Current progress in [0, 1]. */
  value: number;
  /** Called on every range-input change. Receives the new [0, 1] value. */
  onChange: (next: number) => void;
  /** ARIA label describing what the scrubber controls (e.g. "Run playback"). */
  ariaLabel: string;
}

/**
 * Range input used by both 2D + 3D run-playback HUDs. The track's filled
 * region is driven by a `--val` CSS custom property so the gradient
 * follows the slider without per-frame JS. The accessible label is
 * required (no fallback) — coaches need to know what scrubbing changes.
 */
export function HudScrubber({ value, onChange, ariaLabel }: HudScrubberProps) {
  const pct = Math.round(value * 100);
  // `--val` is consumed by the runnable-track gradient in tacticsHud.css.
  // Casting via Record so the inline CSS var typechecks without `any`.
  const style: CSSProperties = { ['--val' as string]: value } as CSSProperties;
  return (
    <input
      type="range"
      className="thud__scrubber"
      min={0}
      max={1}
      step={0.001}
      value={value}
      style={style}
      onChange={(e) => onChange(Number(e.target.value))}
      aria-label={`${ariaLabel}: ${pct}%`}
    />
  );
}
